import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var productQoList = [
    {
        key: "warehouseID",
        render: function(param) {
            var item = param.item, values = param.values, optionsWarehouse = param.optionsWarehouse, setProductRow = param.setProductRow;
            var _item_warehouseID;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.productID && /*#__PURE__*/ _jsxs("select", {
                            value: (_item_warehouseID = item.warehouseID) !== null && _item_warehouseID !== void 0 ? _item_warehouseID : "",
                            style: {
                                width: "100%",
                                border: !item.warehouseID ? "1px solid #dc3545" : "1px solid rgb(223, 225, 229)"
                            },
                            onChange: function(e) {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        var selectedOption = e.target.options[e.target.selectedIndex];
                                        if (el.rowID === item.rowID) {
                                            return _object_spread_props(_object_spread({}, el), {
                                                warehouseID: e.currentTarget.value,
                                                warehouseName: selectedOption.text
                                            });
                                        }
                                        return el;
                                    });
                                });
                            },
                            className: "form-control sselectv",
                            disabled: true,
                            children: [
                                /*#__PURE__*/ _jsx("option", {
                                    value: "",
                                    disabled: true,
                                    children: "เลือกคลัง"
                                }, "default"),
                                optionsWarehouse && optionsWarehouse.map(function(v, index) {
                                    return /*#__PURE__*/ _jsx("option", {
                                        value: v.value,
                                        children: v.label
                                    }, index);
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    }
];
